var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "row gutter-xs" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-9" },
        [
          _c("q-input", {
            attrs: {
              type: "number",
              "float-label": _vm.$t("certificate_expiration_label"),
              disable: _vm.disableInput
            },
            model: {
              value: _vm.days,
              callback: function($$v) {
                _vm.days = $$v
              },
              expression: "days"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-2" },
        [
          _c("q-select", {
            attrs: {
              disable: _vm.disableInput,
              options: _vm.listed_type_calendar,
              "float-label": " "
            },
            model: {
              value: _vm.type_calendar,
              callback: function($$v) {
                _vm.type_calendar = $$v
              },
              expression: "type_calendar"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "10px 2px" } },
        [
          _c(
            "q-icon",
            {
              staticClass: "q-mr-sm q-pt-md",
              attrs: {
                name: "fal fa-question-circle",
                size: "1.5rem",
                color: "grey"
              }
            },
            [
              _c(
                "q-tooltip",
                {
                  staticClass: "custom-tooltip",
                  attrs: { anchor: "top left", self: "bottom right" }
                },
                [
                  _c("p", { staticClass: "q-ma-xs q-pa-xs" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("expire_certificate_information_1")) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _c("p", { staticClass: "q-ma-xs q-pa-xs" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("expire_certificate_information_2")) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }